import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import SearchSelect from "../../common/textfield/SearchSelect";
import { useNavigate } from "react-router-dom";
import { QuestionnaireFormikObj, questionnaireForOptions, questionnaireTagOptions } from "./Constant";
import { Skeleton, Tooltip } from "@mui/material";
import { ArrowBack, ExpandMore, NavigateNext } from "@mui/icons-material";
import { createQuestionnaire } from "../../api/Questionnaire";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";
import { useGetQuestionsByCategoryQuery } from "../../../hooks/ReactQueryHooks/useGetQuestionsByCategoryQuery";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import DeleteIcon from "../../../assets/images/cross-icon.png";
import { getOrganization } from "../../api/Organization";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";

const CreateQuestionnaire = () => {
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [categorySelectedQuestions, setCategorySelectedQuestions] = useState([]);
  const [questionsCategoryList, setQuestionsCategoryList] = useState([]);
  const [err, setErr] = useState("");

  const userOrg = useSelector((state) => state?.auth?.user?.["custom:orgId"]);
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState(userOrg || "");

  // fetch all orgs (or the ones user can see)
  const fetchOrganizations = async () => {
    try {
      const response = await getOrganization();
      setOrganizations(response?.data || []);
      if (!selectedOrgId && response?.data?.length) {
        setSelectedOrgId(response.data[0]?.id);
      }
    } catch (e) {
      // fallback: keep current
    }
  };
  useEffect(() => { fetchOrganizations(); /* eslint-disable-next-line */ }, []);

  const orgOptions = (organizations || []).map((o) => ({
    name: o?.name || o?.display || o?.orgName || o?.id,
    value: o?.id,
  }));
  const orgSelectOptions = orgOptions.map((o) => ({ label: o.name, value: o.value }));

  const formik = useFormik({
    ...QuestionnaireFormikObj,
    initialValues: {
      ...(QuestionnaireFormikObj?.initialValues || {}),
      selectedOrgId: selectedOrgId || userOrg || "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      values.title = values.title?.trim();
      values.purpose = values.purpose?.trim();
      values.note = values.note?.trim();
      const trimmedTag = values.questionnaireTag?.trim() || "";
      values.questionnaireTag = trimmedTag === "none" ? "" : trimmedTag;
      const tempQuestionsArr = [];
      let locationQuestions = 0;
      let reasonQuestions = 0;
      let questionTELEPHONE = 0;
      let questionCHANNEL = 0;
      let questionRELATIONSHIP = 0;
      let questionSELFCALLING = 0;
      let questionCONSENT = 0;
      let questionCALLER = 0;
      let questionINCLINATION = 0;
      let questionCOMPLIANCE = 0;

      categorySelectedQuestions?.forEach((question) => {
        tempQuestionsArr.push({
          text: question?.question,
          id: question?.id,
          required: !!question?.required,
          question: question?.question,
          answerType: question?.answerType,
          answerOption: question?.options,
          note: question?.note,
          tag: question?.tag || "",
        });

        if (question.tag === "LOCATION") locationQuestions += 1;
        if (question.tag === "REASON") reasonQuestions += 1;
        if (question.tag === "TELEPHONE") questionTELEPHONE += 1;
        if (question.tag === "CHANNEL") questionCHANNEL += 1;
        if (question.tag === "RELATIONSHIP") questionRELATIONSHIP += 1;
        if (question.tag === "SELFCALLING") questionSELFCALLING += 1;
        if (question.tag === "CONSENT") questionCONSENT += 1;
        if (question.tag === "CALLER") questionCALLER += 1;
        if (question.tag === "INCLINATION") questionINCLINATION += 1;
        if (question.tag === "COMPLIANCE") questionCOMPLIANCE += 1; 
      });

      // ----- validations (unchanged except for brevity here) -----
      if (formik.values?.purpose?.includes("video-visit")) {
          if(questionCOMPLIANCE > 1) {
            setErr("You Have Selected More Than One Question Marked With Patient Compliance");
            return;
          }
      }
      
      if (formik.values?.purpose?.includes("getcare")) {
        if (!reasonQuestions && !locationQuestions && !questionTELEPHONE && !questionCHANNEL) {
          setErr("Must Select These Questions :- Patient Location, Reason for visit, Return Telephone Number and Preferred Channel");
          return;
        }
        // ... keep your existing exhaustive checks ...
        if (!locationQuestions || locationQuestions > 1) {
          setErr(!locationQuestions ? "Must Select a Question :- Patient Location" : "You Have Selected More Than One Question Marked With Patient Location");
          return;
        }
        if (!reasonQuestions || reasonQuestions > 1) {
          setErr(!reasonQuestions ? "Must Select a Question :-  Reason for visit" : "You Have Selected More Than One Question Marked With  Reason for visit");
          return;
        }
        if (!questionTELEPHONE || questionTELEPHONE > 1) {
          setErr(!questionTELEPHONE ? "Must Select a Question :- Return Telephone Number" : "You Have Selected More Than One Question Marked With Return Telephone Number");
          return;
        }
        if (!questionCHANNEL || questionCHANNEL > 1) {
          setErr(!questionCHANNEL ? "Must Select a Question :- Preferred Channel" : "You Have Selected More Than One Question Marked With Preferred Channel");
          return;
        }

      }

      if (formik.values?.purpose?.includes("clinical-visit") && categorySelectedQuestions.length === 0) {
        setErr("Must Select a Question");
        return;
      }

      if (formik.values?.purpose?.includes("telephone-intake")) {
        if (
          !reasonQuestions &&
          !locationQuestions &&
          !questionTELEPHONE &&
          !questionRELATIONSHIP &&
          !questionSELFCALLING &&
          !questionCONSENT &&
          !questionCALLER
        ) {
          setErr("Must Select These Questions :-  Reason for visit, Patient Location, Return Telephone Number, Relationship to patient, Calling for yourself, Patient Consent and Caller Name");
          return;
        }
        // ... keep your existing exhaustive checks ...
        if (!locationQuestions || locationQuestions > 1) {
          setErr(!locationQuestions ? "Must Select a Question :- Patient Location" : "You Have Selected More Than One Question Marked With Patient Location");
          return;
        }
        if (!reasonQuestions || reasonQuestions > 1) {
          setErr(!reasonQuestions ? "Must Select a Question :-  Reason for visit" : "You Have Selected More Than One Question Marked With  Reason for visit");
          return;
        }
        if (!questionTELEPHONE || questionTELEPHONE > 1) {
          setErr(!questionTELEPHONE ? "Must Select a Question :- Return Telephone Number" : "You Have Selected More Than One Question Marked With Return Telephone Number");
          return;
        }
        if (!questionRELATIONSHIP || questionRELATIONSHIP > 1) {
          setErr(!questionRELATIONSHIP ? "Must Select a Question :- Relationship to patient" : "You Have Selected More Than One Question Marked With Relationship to patient");
          return;
        }
        if (!questionSELFCALLING || questionSELFCALLING > 1) {
          setErr(!questionSELFCALLING ? "Must Select a Question :-  Calling for yourself" : "You Have Selected More Than One Question Marked With  Calling for yourself");
          return;
        }
        if (!questionCONSENT || questionCONSENT > 1) {
          setErr(!questionCONSENT ? "Must Select a Question :- Patient Consent" : "You Have Selected More Than One Question Marked With Patient Consent");
          return;
        }
        if (!questionCALLER || questionCALLER > 1) {
          setErr(!questionCALLER ? "Must Select a Question :-  Caller Name" : "You Have Selected More Than One Question Marked With Caller Name");
          return;
        }
        if( questionINCLINATION > 1) {
          setErr("You Have Selected More Than One Question Marked With Patient Inclination");
          return;
        }
      }

      setBtnLoading(true);
      createQuestionnaire({
        ...values,
        orgId: selectedOrgId || userOrg, // <-- create for selected org
        question: tempQuestionsArr,
      })
        .then((res) => {
          success(res.message);
          setBtnLoading(false);
          // Show overlay loading for 3 seconds then navigate
          setOverlayLoading(true);
          setTimeout(() => {
            setOverlayLoading(false);
            navigate("/app/manage-questionnaire");
          }, 3000);
        })
        .catch((res) => {
          failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
          setBtnLoading(false);
        });
    },
  });

  const onSuccess = (data) => {
    setQuestionsCategoryList(data);
    setCategorySelectedQuestions([]);
    setErr("");
  };

  // Load categories/questions for the selected org + current purpose
  const { isLoading, isFetching } = useGetQuestionsByCategoryQuery({
    onSuccess,
    purpose: formik?.values?.purpose,
    orgId: selectedOrgId || userOrg, // <-- use selected org here
    refetchOnWindowFocus: false,
  });

  // Reset selected questions when org or purpose changes
  useEffect(() => {
    setCategorySelectedQuestions([]);
    setQuestionsCategoryList([])
    setErr("");
  }, [selectedOrgId, formik.values?.purpose]);

  const handleSelectedQuestions = (question) => {
    setErr("");
    if (!categorySelectedQuestions?.some((item) => item?.id === question?.id)) {
      setCategorySelectedQuestions([question, ...categorySelectedQuestions]);
    } else {
      setCategorySelectedQuestions(categorySelectedQuestions.filter((item) => item?.id !== question?.id));
    }
  };

  // const handleToggleExcludeFromExtReports = (index) => {
  //   const updated = [...categorySelectedQuestions];
  //   updated[index] = {
  //     ...updated[index],
  //     excludeFromExtReports: !updated[index].excludeFromExtReports
  //   };
  //   setCategorySelectedQuestions(updated);
  // };

  const handleDrop = (droppedItem) => {
    setErr("");
    if (!droppedItem.destination) return;
    const updatedList = [...categorySelectedQuestions];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    setCategorySelectedQuestions(updatedList);
  };

  const handleDeleteQuestion = (index) => {
    setErr("");
    const updatedList = [...categorySelectedQuestions];
    updatedList.splice(index, 1);
    setCategorySelectedQuestions(updatedList);
  };

  const handleOrgChange = (selected) => {
    const newOrgId = selected?.value || "";
    setSelectedOrgId(newOrgId);
    formik.setFieldValue("selectedOrgId", newOrgId);
    formik.setFieldValue("purpose", "");
  };

  return (
    <section className="common-listing">
      {overlayLoading && <FullPageSpinner loadingText="Saving..." />}
      <div className="heading-wrap mb-3">
        <Tooltip title="Go back">
          <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
            <ArrowBack />
          </div>
        </Tooltip>
      </div>

      <div className="custom-card p-4">
        <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
          {/* NEW: Organization selector */}
          <Row>
            <Col>
              <SearchSelect
                keyField="selectedOrgId"
                label="Organization"
                formik={formik}
                placeholder="Select Organization"
                options={orgSelectOptions}
                value={orgSelectOptions.find((o) => o.value === formik.values.selectedOrgId) || null}
                required={true}
                isClearable={false}
                onChange={handleOrgChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput keyField={"title"} label={"Title"} formik={formik} placeholder={"Title"} />
            </Col>

            <Col>
              <SelectFiled
                keyField={"purpose"}
                label={"Workflow"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireForOptions}
                value={formik.values?.purpose}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <SelectFiled
                keyField={"questionnaireTag"}
                label={"Questionnaire Tag"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireTagOptions}
                value={formik.values?.questionnaireTag}
                required={false}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <h6>Available Categories</h6>
              {isLoading || isFetching ? (
                <ul className="questionnaire-list">
                  {[1, 2, 3, 4, 5, 6, 7].map((val) => (
                    <li key={val}>
                      <Skeleton width={"100%"} animation="wave" />
                    </li>
                  ))}
                </ul>
              ) : (
                <ul className="questionnaire-list">
                  {questionsCategoryList?.map((category) => (
                    <Accordion key={category?.id}>
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography>{category?.categoryName}</Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: 0 }}>
                        <ul className="questionnaire-list">
                          {[...(category?.questions || [])]
                            .sort((a, b) => (a?.question || "").localeCompare(b?.question || ""))
                            .map((question) => (
                              <li key={question?.id} onClick={() => handleSelectedQuestions(question)}>
                                {question?.question}
                                <NavigateNext style={{ float: "right" }} />
                              </li>
                            ))}
                        </ul>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </ul>
              )}
            </Col>

            <Col>
              <h6>Selected Questions</h6>
              {categorySelectedQuestions?.length ? null : <div>No available question selected</div>}

              <Tooltip title={"Drag to Reorder Questions"}>
                <ul className="questionnaire-list">
                  <DragDropContext onDragEnd={handleDrop}>
                    <Droppable droppableId="list-container">
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {categorySelectedQuestions?.map((item, index) => (
                            <Draggable key={item?.id || item?.question} draggableId={(item?.id || item?.question).toString()} index={index}>
                              {(provided, snapshot) => (
                                <li
                                  key={index}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "space-between", 
                                    gap: "10px",
                                    ...provided.draggableProps.style,
                                    backgroundColor: snapshot.isDragging ? '#f0f0f0' : 'transparent'
                                  }}
                                >
                                  <span 
                                    style={{ flex: 1, cursor: 'grab' }}
                                    {...provided.dragHandleProps}
                                  >
                                    {item?.question}
                                  </span>
                                  <img
                                    src={DeleteIcon}
                                    alt="Delete"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteQuestion(index);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </li>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </ul>
              </Tooltip>

              <div style={{ fontSize: "14px", color: "#dc3545", paddingTop: "5px" }}>{err}</div>
            </Col>
          </Row>

          {formik.touched.question && formik.errors.question && (
            <div className="error" style={{ fontSize: "14px", color: "#dc3545", paddingTop: "5px" }}>
              {formik.errors.question}
            </div>
          )}

          <div className="btn-wrap" style={{ display: "flex", marginTop: "2rem" }}>
            <Button variant="secondary" title="Cancel" onClick={() => navigate("/app/manage-questionnaire")}>
              Cancel
            </Button>
            <Button type="submit" isLoading={btnLoading}>
              Create
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CreateQuestionnaire;